import React, { useCallback, useState } from 'react'
import { withRouter } from 'react-router'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { toast } from 'react-toastify'

// reactstrap components
import { Button, Container, Row, Col, Form, Input, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap'
import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { UsersService } from 'services/users'
import Loading from 'components/Loading/Loading'

const schema = yup.object().shape({
  Email: yup.string().email('Informe um e-mail válido').required('Por favor, informe um e-mail').nullable(),
})

const RecuperaSenhaPage = ({ history }) => {
  const { errors, register, handleSubmit } = useForm({ resolver: yupResolver(schema) })
  const { executeRecaptcha } = useGoogleReCaptcha()

  const [isLoading, setIsLoading] = useState(false)

  const goBack = useCallback(() => {
    history.push('/login')
  }, [history])

  const onSubmit = useCallback(
    async (value) => {
      setIsLoading(true)

      const Captcha = await executeRecaptcha('recuperar_senha_pagina')

      try {
        const response = await UsersService.forgotPassword({ Email: value.Email, Captcha })
        if (response.status === 200) {
          toast.success('Sucesso! Foi enviado para o seu e-mail instruções para você redefinir sua senha')
          history.push('/login')
        }
      } catch (e) {
        toast.error(e?.response?.data || e.message)
      } finally {
        setIsLoading(false)
      }
    },
    [executeRecaptcha, history]
  )

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="12">
              <p
                className="description"
                style={{
                  fontWeight: 400,
                  color: '#000',
                  letterSpacing: 2,
                  lineHeight: 1.6,
                  marginTop: 30,
                }}
              >
                <span style={{ fontWeight: 600 }}>Esqueceu sua senha? É fácil recuperar.</span> <br />
                Digite seu e-mail que iremos enviar as instruções.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="text-center" style={{ marginTop: 30, marginBottom: 30 }}>
          <Form id="consulta-form" className="consulta-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="title-brand" style={{ marginTop: 15 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 19,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-email-85" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  placeholder="Digite aqui o e-mail cadastrado"
                  type="text"
                  name="Email"
                  id="Email"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
              {errors?.Email?.message && <span style={{ color: 'red' }}>{errors?.Email?.message}</span>}
            </div>
            <div className="title-brand" style={{ marginTop: 12, letterSpacing: 4, marginBottom: 0 }}>
              {isLoading ? (
                <Loading />
              ) : (
                <Button
                  errors={Object.keys(errors).length <= 0}
                  className="btn-round"
                  type="submit"
                  style={{
                    paddingTop: 10,
                    paddingBottom: 5,
                    fontSize: 14,
                    letterSpacing: 4,
                    textTransform: 'none',
                    backgroundColor: '#16057C',
                    color: '#FFF',
                    border: 0,
                    width: '100%',
                    height: 45,
                    borderRadius: 20,
                  }}
                >
                  Recuperar Senha
                </Button>
              )}
            </div>
          </Form>
        </Container>

        <WhiteFooter />
      </div>
    </>
  )
}

export default withRouter(RecuperaSenhaPage)
